module.exports = __webpack_public_path__ + "img/visionaries-card-two-mobile.ec493124.png";